<script>
    import { _ } from "../../services/i18n";
</script>

<section class="section-elements">
    <table class="table-elements">
        <tr>
            <td class="box-elements" id="r-box">
                <a href="#/tuto?/orders/details/status">
                    <h5>{$_("tutorial_orders_detail_status")}</h5>
                    <div class="info-elements">
                        <p>Saber más</p>
                        <img
                            id="user-elements"
                            src="/icons/arrow-left-white.svg"
                            alt="user"
                        />
                    </div>
                    <img
                        id="element-elements"
                        src="/icons/eye2.svg"
                        alt="eye"
                    />
                </a>
            </td>
            <td class="box-elements" id="d-box">
                <a href="#/tuto?/orders/details/preview">
                    <h5>{$_("tutorial_orders_detail_preview")}</h5>
                    <div class="info-elements">
                        <p>Saber más</p>
                        <img
                            id="user-elements"
                            src="/icons/arrow-left-white.svg"
                            alt="close"
                        />
                    </div>
                    <img
                        id="element-elements"
                        src="/icons/add-fav-sim3d-white.svg"
                        alt="add"
                    />
                </a>
            </td>
        </tr>
        <tr>
            <td class="box-elements" id="b-box">
              <a href="#/tuto?/orders/details/visor">
                <h5>{$_("tutorial_budget_detail_visor")}</h5>
                <div class="info-elements">
                  <p>Saber más</p>
                  <img id="user-elements" src="/icons/arrow-left-white.svg" alt="close" />
                </div>
                <img id="element-elements" src="/icons/video-3d-variant.svg" alt="pencil" />
              </a>
            </td>
          </tr>
        <!-- <tr>
            <td class="box-elements" id="g-box">
                <a href="#/tuto?/orders/details/ticket">
                    <h5>{$_("tutorial_orders_detail_ticket")}</h5>
                    <div class="info-elements">
                        <p>Saber más</p>
                        <img
                            id="user-elements"
                            src="/icons/arrow-left-white.svg"
                            alt="close"
                        />
                    </div>
                    <img
                        id="element-elements"
                        src="/icons/info-circle.svg"
                        alt="info"
                    />
                </a>
            </td>
        </tr> -->
    </table>
</section>
